<template>
    <div class="game_container">
        <!-- 게임 버튼은 외부 데이터셋(public/games.json)을 읽어 자동 생성.
             구조/클래스/판정 로직은 기존과 동일 — 하드코딩만 v-for로 대체. -->
        <div class="game_list_container" v-for="(group, gi) in gameGroups" :key="gi">
            <div class="game_list_title" v-if="isGroupVisible(group)">{{ group.title }}</div>
            <div class="game_btn_container">
                <div v-for="(g, gci) in group.games" :key="g.type + '_' + gci"
                     type="button" class="game_start_btn"
                     :style="{ backgroundImage: 'url(' + imgUrl(g.img) + ')' }"
                     @click="checkGameState(g.type)"
                     :class="{ hidden: !checkServiceState(g.type) }" />
            </div>
        </div>
    </div>
    
</template>

<script>
import store from '../components/js/store.js'

import Swal from "sweetalert2";
import API from '@/components/js/API';
import axios from 'axios';
export default {

    name: 'HomeView',
    components:
    {
        
    },
    data() {
        return {
            // 외부 데이터셋(public/games.json)에서 로드되는 게임 목록.
            // 형식: [{ title, games: [{ type, img }] }]
            gameGroups: []
        }
    },
    mounted(){
        window.addEventListener("message", this.handleMessage);
        this.loadGameList();
    },
    methods: {
        handleMessage(event) {
            console.log("[홈페이지] 메시지 받음:", event.data); // ← 모든 메시지 확인

            if (typeof event.data === 'object' && event.data.action === 'reconnect') {
                console.log("게임 재접속 요청:", event.data.gameType);
                this.checkGameState(event.data.gameType);
                return;
            }
            if (typeof event.data === 'string')
            {
                if (event.data.includes('Closed')) {
                    console.log("game : Closed");
                    store.commit('popupStateChange', { key: 'game', value: false });
                }
            }
        },
        check_page: function(){

        },
        // 외부 데이터셋 로드 — 리빌드 없이 게임 추가/제거 가능.
        // 캐시버스팅(?v=timestamp)으로 games.json 갱신이 즉시 반영되게 함.
        loadGameList() {
            const base = process.env.BASE_URL || '/';
            axios.get(base + 'games.json?v=' + Date.now())
                .then((res) => {
                    this.gameGroups = Array.isArray(res.data) ? res.data : [];
                    // 게임 type 목록을 store 기본값 채우기에 전달(단일 출처 = games.json).
                    const types = [];
                    this.gameGroups.forEach(g => (g.games || []).forEach(x => types.push(x.type)));
                    console.log('[games.json] 로드된 게임 리스트:', types, this.gameGroups);
                    store.commit('applyGameListDefaults', types);
                })
                .catch((err) => {
                    console.error('games.json 로드 실패:', err);
                    this.gameGroups = [];
                });
        },
        // public/img/ 경로 참조(require 대신) — 새 이미지도 리빌드 없이 드롭.
        imgUrl(name) {
            const base = process.env.BASE_URL || '/';
            return base + 'img/' + name;
        },
        // 그룹 내 게임 중 하나라도 서비스 on이면 타이틀 노출(기존 조건과 동일).
        isGroupVisible(group) {
            if (!group || !group.games) return false;
            return group.games.some((g) => this.checkServiceState(g.type));
        },
        checkGameState(type) {
            const _t = 'game'+type;
            console.log(_t + ' setting is ' + store.state.game_setting[_t]);
            if (store.state.game_setting[_t] == 1){
                this.get_token(type);
            }
            else {
                Swal.fire({
                    icon: 'warning',
                    text: '해당 게임은 현재 준비 중입니다.',
                    confirmButtonText: '확인',
                })
            }
        },
        checkServiceState(type) {
            const _t = 'game'+type;
            const _p = store.state.user.preset;

            const presetSettings = store.state.preset_setting[_p];

            if (presetSettings) {
                if (presetSettings[_t] == 1) {
                    return true;
                }
                else {
                    console.log(_t + ' service off ');
                    return false;
                }
            }
        },
        get_token: function(type){
            if(!this.$root.bLogin)
            {
                Swal.fire({
                    icon: 'info',
                    title: '로그인 후 이용 가능합니다.',
                    text: '로그인 하시겠습니까?',
                    showCancelButton: true,
                    confirmButtonText: '확인',
                    cancelButtonText: '취소'
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.$root.pModalViewed = true;
                        this.$root.pLogin = true;
                    }
                })
                return;
            }

            API.checkToken(()=>{
                const form = {
                    user_id: store.state.user.id,
                    site: 'pang-play'
                }
                // 게임 종류와 무관하게 항상 동일한 창 name을 사용하여
                // 게임 창은 전체에서 하나만 열리도록 한다.
                const name = 'game';
                API.AxiosPost('users/getToken', form, true,
                    (res) => {
                        if (res.data.code == 200) {
                            console.log(name);
                            this.onClickRedirect(res.data.token, type, name);
                        } else {
                            console.log("return code : " + res.data.code);
                        }
                    }
                )
            })
            
        },

        login_success: function(){
            this.$emit('close');
        },
        onClickRedirect: function (_token, _type, _name) {
            // 통합 빌드: 모든 게임이 Game/index.html을 호출하고 type 인자로 분기
            // (EOS=1, Pang=2, PGB=3, DH=4, P_Race=5, Bingo=6, LowHigh=7)
            const urlStr = API.DOMAIN() + "Game/index.html";

            let urlParams = new URLSearchParams();
            urlParams.append("token", _token);
            urlParams.append("id", store.state.user.id);
            urlParams.append("type", _type);
            this.openPopup(urlStr+"?"+urlParams, _name, 'width=1600,height=900,status=no,toolbar=no,scrollbars=no,location=no')
            //window.open(urlStr+"?"+urlParams, "_blank", 'width=1600,height=900,status=no,toolbar=no,scrollbars=no,location=no');    
        },
        openPopup: function (url, name, specs) {
            const pop = window.open(url, name, specs);
            if (pop) {
                console.log(name + " : Open!");
                store.commit('popupStateChange', { key: name, value: true });
            }

            const trueKeys = [];
            for (const key in store.state.game_pop_state) {
                if (store.state.game_pop_state[key]) {
                    trueKeys.push(key);
                }
            }
            console.log(trueKeys);
        }
    }
}
</script>

<style>
@font-face {
    font-family: 'AgencyFB-Bold'; /*font 이름*/
    src: url('../assets/AgencyFB-Bold.ttf')
}

.game_container{
    width: 900px;
    height: auto;
    margin: 0px auto;
    padding: 30px 30px 120px 120px;
}
.game_list_title{
    width: 100%;
    height: 50px;
    margin-top: 5px;
    align-items: center;
    font-family: 'AgencyFB-Bold';
    text-align: left;
    font-size: 28px;
    font-weight: bold;
    color: #0d6efd;
    
}
.game_list_container{
    width: 100%;
    height: auto;
    margin: 0 auto;
    display:block;
    justify-content: left;
    align-items: left;
    text-align: left;
}
.game_btn_container{
    width: 100%;
    height: auto;
    margin: 0 auto;
    display: flex;
    justify-content: left;
    align-items: left;
    text-align: left;
}
.game_start_btn{
    float: left;
    background-size: 175px 225px;
    width: 175px;
    height: 225px;
    margin: 10px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 1);
}
.hidden {
    display: none;
}
</style>
@/components/js/API.js